import { render, staticRenderFns } from "./payment-confirm.component.vue?vue&type=template&id=7748a0ec"
import script from "./payment-confirm.component.vue?vue&type=script&lang=js"
export * from "./payment-confirm.component.vue?vue&type=script&lang=js"
import style0 from "./payment-confirm.component.vue?vue&type=style&index=0&id=7748a0ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports